import React, { useState, useLayoutEffect } from 'react';
// @mui
// 다국어
import { useTranslation } from 'react-i18next';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import { Button, Link, TextField, CssBaseline } from '@mui/material';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import bottomBG from '../../image/bottom_bg.png';
import QuestionImg from '../../image/img_question.png';
import ContactModal from './Contact';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const FAQTitle = styled('h1')({
  fontWeight: 500,
  paddingLeft: '80px',
  background: `url(${QuestionImg}) no-repeat`,
  backgroundSize: '60px',
  backgroundPosition: 'left top',
});

const StyledAccordionSummary = styled(AccordionSummary)({
  padding: '20px 0',
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
  },
});

const Licensefull = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'Column',
  margin: '0 auto',
  background:
    'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)), linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
  textAlign: 'center',
  padding: theme.spacing(7, 0),
  color: '#fff',
}));

const DownloadButton = styled(Button)({
  marginTop: '40px',
  fontSize: '1.2rem',
  fontWeight: 500,
  fontFamily: 'Pretendard-Regular',
  padding: '1rem 4rem',
});

const ContentTextField = styled(TextField)({
  input: {
    height: '100%',
  },
});

export default function FAQ() {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const [expanded, setExpanded] = React.useState('panel1');

  const [contactModalOpen, setContactModalOpen] = React.useState(false);

  const contactHandleOpen = () => {
    setContactModalOpen(true);
  };
  const contactHandleClose = () => {
    setContactModalOpen(false);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // ----------------------------------------------------------------------

  return (
    <>
      <CssBaseline />
      <div style={{ padding: '60px 10%' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            borderBottom: '2px solid #111',
            paddingBottom: '40px',
          }}
        >
          <FAQTitle>{t('무엇을 도와드릴까요?')}</FAQTitle>
          <DownloadButton
            sx={{ backgroundColor: '#4E45F5', color: '#fff', border: 'none', margin: 0 }}
            onClick={contactHandleOpen}
          >
            {t('빠른 문의하기')}
          </DownloadButton>
        </div>
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{ padding: 0 }}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ padding: '20px 0' }}
          >
            <Typography sx={{ color: '#1A9EF8', width: '100px' }}>{t('레인드롭')}</Typography>
            <Typography sx={{ flexShrink: 0, flex: 1, fontSize: '1.4rem' }}>
              {t('회원가입은 어떻게 하나요?')}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1rem' }}>{t('회원가입은 로그인 페이지에서 가능해요.')}</Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} style={{ padding: 0 }}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            style={{ padding: '20px 0' }}
          >
            <Typography sx={{ color: '#1A9EF8', width: '100px' }}>{t('레인드롭')}</Typography>
            <Typography sx={{ flexShrink: 0, flex: 1, fontSize: '1.4rem' }}>
              {t('레인드롭은 어떤 프로그램인가요?')}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1rem' }}>
              {t(
                '레인드롭은 치과 기공소 운영에 필요한 모든 기능을 통합적으로 제공하는 올인원(All-in-One) 기공소 관리 프로그램입니다.'
              )}
              <br />{' '}
              {t(
                '의뢰서 관리, 제작 일정 관리, 미수금 관리, 거래처 관리, 통계 등 기공소 운영에 필요한 모든 업무를 효율적으로 관리할 수 있습니다.'
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} style={{ padding: 0 }}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            style={{ padding: '20px 0' }}
          >
            <Typography sx={{ color: '#1A9EF8', width: '100px' }}>{t('레인드롭')}</Typography>
            <Typography sx={{ flexShrink: 0, flex: 1, fontSize: '1.4rem' }}>
              {t('레인드롭은 무료로 사용 할 수 있나요?')}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1rem' }}>
              {t(
                '레인드롭은 월 접수 200건이 가능한 무료 플랜을 기본적으로 제공하고 있습니다. 무료 플랜이 부족하다면 다음 플랜을 구매하여 사용해보세요.'
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} style={{ padding: 0 }}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            style={{ padding: '20px 0' }}
          >
            <Typography sx={{ color: '#1A9EF8', width: '100px' }}>{t('레인드롭')}</Typography>
            <Typography sx={{ flexShrink: 0, flex: 1, fontSize: '1.4rem' }}>
              {t('레인드롭은 어떻게 설치하나요?')}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1rem' }}>
              {t('레인드롭은 회원 가입 후 간편하게 다운로드 가능해요. 설치 후 로그인은 웹사이트 계정으로 가능해요.')}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')} style={{ padding: 0 }}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            style={{ padding: '20px 0' }}
          >
            <Typography sx={{ color: '#1A9EF8', width: '100px' }}>{t('레인드롭')}</Typography>
            <Typography sx={{ flexShrink: 0, flex: 1, fontSize: '1.4rem' }}>
              {t('레인드롭은 어떤 기공소에 적합한가요?')}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1rem' }}>
              {t(
                '레인드롭은 모든 규모의 기공소에 적합해요. 소규모의 1인 기공소 부터 여러 명의 직원이 함께 사용하는 기공소까지, 업무 효율성을 높이고 체계적인 운영이 가능해요.'
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')} style={{ padding: 0 }}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel6bh-content"
            id="panel6bh-header"
            style={{ padding: '20px 0' }}
          >
            <Typography sx={{ color: '#1A9EF8', width: '100px' }}>{t('레인드롭')}</Typography>
            <Typography sx={{ flexShrink: 0, flex: 1, fontSize: '1.4rem' }}>
              {t('프로그램 사용 중 문제가 발생하면 어떻게 하나요?')}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails>
            <Typography sx={{ fontSize: '1rem' }}>
              {t(
                '프로그램 사용 시 불편 사항이나 문제가 발생했을 경우 홈페이지 내 문의하기 및 유선 전화를 이용해주세요. 업무 시간 내에 문의 해결이 가능해요.'
              )}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
      <Licensefull sx={{ background: `url(${bottomBG}) no-repeat bottom center`, alignItems: 'center' }}>
        <h2>{t('원하는 답변을 찾지 못하셨나요?')}</h2>
        <p style={{ fontSize: '1.2rem', marginTop: '10px' }}>{t('1:1문의를 등록하시면 답변해드려요!')}</p>
        <DownloadButton sx={{ backgroundColor: '#4E45F5', color: '#fff', border: 'none' }} onClick={contactHandleOpen}>
          {t('빠른 문의하기')}
        </DownloadButton>
      </Licensefull>
      <ContactModal modalOpen={contactModalOpen} pContactHandleClose={contactHandleClose} />

      {/* <Modal
        open={contactOpen}
        onClose={contactHandleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...modalStyle, width: 800,display:'flex', flexDirection:'column', padding:'60px', border:'1px solid #ddd',borderRadius:'40px'}}>
          <div style={{display:'flex', flexDirection:'column', alignItems:'center',marginBottom:'40px'}}>
            <h2 id="parent-modal-title">빠른 문의하기</h2>
            <p style={{marginTop:'10px'}}>빠르게 검토 후 연락드릴게요!</p>
          </div>
          <div>
            <TextField required fullWidth id="inquiryname" name="inquiryname" label="이름을 입력하세요." />
            <TextField sx={{marginTop:'10px'}} required fullWidth id="inquiryemail" name="inquiryemail" label="이메일 주소를 입력하세요." />
            <TextField sx={{marginTop:'10px'}} required fullWidth id="inquiryphone" name="inquiryphone" label="연락처를 입력하세요." />
            <TextField sx={{marginTop:'10px'}} required id="parent-modal-description" fullWidth multiline rows={10} label="문의 내용을 입력하세요."/>
          </div>
          <div>
          <Link href="#">개인정보취급방침</Link>에 동의합니다.
          </div>
          <div style={{marginTop:'40px',textAlign:'center'}}>
            <Button variant="contained">문의하기</Button>
          </div>        
        </Box>
      </Modal> */}
    </>
  );
}
